import _ from 'lodash'

export function deflattenObject(list: any[]) {
   const companies: any[] = []
   list.forEach((element: any) => {
      const keys = Object.keys(element)
      const company = {} as any
      keys.forEach((key: string) => {
         if (key.length) {
            const transformedKey = transformKey(key)
            const value = element[key]
            if (value != undefined && value != null) {
               if (value == 'TRUE' || value == 'FALSE' || value == 'true' || value == 'false') {
                  _.set(company, transformedKey, (value == 'TRUE' || value == 'true') ? true : false)
               } else {
                  _.set(company, transformedKey, value)
               }
            }
         }
      })
      companies.push(company)
   })
   return companies
}

export function transformKey(key: string) {
   return key.replace(/_/g, ".");
}

export function capitalizeFirstLetter(string: string) {
   return string.charAt(0).toUpperCase() + string.slice(1);
}

export function deCapitalizeFirstLetter(string: string) {
   return string.charAt(0).toLowerCase() + string.slice(1);
}

export function exportListToCSV(
   data: any[],
   fileName: string,
   keyOrder?: string[],
   exactKeyMatch?: boolean
) {
   const result = data.map(
      (object) => {

         const flattedObject = flatten(object)
         let ordered: any = {}
         if (keyOrder) {
            if ((exactKeyMatch ?? false) == true) {
               Object.keys(flattedObject).forEach(
                  (key) => {
                     keyOrder.forEach((subKey) => {
                        if (key.includes(subKey)) {
                           const value = flattedObject[key]
                           ordered[key] = value ?? null
                        }
                     })
                  }
               )
            } else {
               keyOrder?.forEach(
                  (key) => {
                     const value = flattedObject[key]
                     ordered[key] = value ?? null
                  })
            }
         } else {
            ordered = flattedObject
         }
         return ordered
      }
   )

   const { Parser } = require('json2csv');
   try {
      const parser = new Parser();
      const csv = parser.parse(result)
      const element = document.createElement("a");
      const file = new Blob([csv], { type: 'text/csv' });
      element.href = URL.createObjectURL(file);
      element.download = `${fileName}.csv`;
      document.body.appendChild(element); // Required for this to work in FireFox
      element.click();
   } catch (err) {
      console.error(err);
   }
}

export function downloadJSON(fileName: string, json: any) {
   try {
      const element = document.createElement("a");
      const file = new Blob([json], { type: 'application/json' });
      element.href = URL.createObjectURL(file);
      element.download = `${fileName}`;
      document.body.appendChild(element); // Required for this to work in FireFox
      element.click();
   } catch (err) {
      console.error(err);
   }
}

export const flatten = (
   obj: any,
   prefix = '',
   res = {} as any,
   ignoreKeys = ['tags', 'matches'],
   separator?: string
) =>
   Object.entries(obj).reduce((r, [key, val]) => {

      const k = `${prefix}${key}`
      if (val != null) {
         if (typeof val === 'object') {
            flatten(val, `${k}${separator ?? '_'}`, r)
         } else {
            const result = ignoreKeys.find((key) => {
               return k.startsWith(key)
            })
            if (result == null) {
               res[k] = val as any
            }
         }
      }
      return r
   }, res)


export type State = {
   name: string,
   code: string
}

export const getStatesByCountry = () => {
   return {
      'United States': getStates(),
      'Canada': [
         { code: 'AB', name: 'Alberta' },
         { code: 'BC', name: 'British Columbia' },
         { code: 'MB', name: 'Manitoba' },
         { code: 'NB', name: 'New Brunswick' },
         { code: 'NL', name: 'Newfoundland and Labrador' },
         { code: 'NS', name: 'Nova Scotia' },
         { code: 'ON', name: 'Ontario' },
         { code: 'PE', name: 'Prince Edward Island' },
         { code: 'QC', name: 'Québec' },
         { code: 'SK', name: 'Saskatchewan' },
         { code: 'NT', name: 'Northwest Territories' },
         { code: 'NU', name: 'Nunavut' },
         { code: 'YT', name: 'Yukon' }
      ] as State[]
   }
}

export const getStates = (): State[] => [
   {
      "name": "Alabama",
      "code": "AL"
   },
   {
      "name": "Alaska",
      "code": "AK"
   },
   {
      "name": "American Samoa",
      "code": "AS"
   },
   {
      "name": "Arizona",
      "code": "AZ"
   },
   {
      "name": "Arkansas",
      "code": "AR"
   },
   {
      "name": "California",
      "code": "CA"
   },
   {
      "name": "Colorado",
      "code": "CO"
   },
   {
      "name": "Connecticut",
      "code": "CT"
   },
   {
      "name": "Delaware",
      "code": "DE"
   },
   {
      "name": "District Of Columbia",
      "code": "DC"
   },
   {
      "name": "Federated States Of Micronesia",
      "code": "FM"
   },
   {
      "name": "Florida",
      "code": "FL"
   },
   {
      "name": "Georgia",
      "code": "GA"
   },
   {
      "name": "Guam",
      "code": "GU"
   },
   {
      "name": "Hawaii",
      "code": "HI"
   },
   {
      "name": "Idaho",
      "code": "ID"
   },
   {
      "name": "Illinois",
      "code": "IL"
   },
   {
      "name": "Indiana",
      "code": "IN"
   },
   {
      "name": "Iowa",
      "code": "IA"
   },
   {
      "name": "Kansas",
      "code": "KS"
   },
   {
      "name": "Kentucky",
      "code": "KY"
   },
   {
      "name": "Louisiana",
      "code": "LA"
   },
   {
      "name": "Maine",
      "code": "ME"
   },
   {
      "name": "Marshall Islands",
      "code": "MH"
   },
   {
      "name": "Maryland",
      "code": "MD"
   },
   {
      "name": "Massachusetts",
      "code": "MA"
   },
   {
      "name": "Michigan",
      "code": "MI"
   },
   {
      "name": "Minnesota",
      "code": "MN"
   },
   {
      "name": "Mississippi",
      "code": "MS"
   },
   {
      "name": "Missouri",
      "code": "MO"
   },
   {
      "name": "Montana",
      "code": "MT"
   },
   {
      "name": "Nebraska",
      "code": "NE"
   },
   {
      "name": "Nevada",
      "code": "NV"
   },
   {
      "name": "New Hampshire",
      "code": "NH"
   },
   {
      "name": "New Jersey",
      "code": "NJ"
   },
   {
      "name": "New Mexico",
      "code": "NM"
   },
   {
      "name": "New York",
      "code": "NY"
   },
   {
      "name": "North Carolina",
      "code": "NC"
   },
   {
      "name": "North Dakota",
      "code": "ND"
   },
   {
      "name": "Northern Mariana Islands",
      "code": "MP"
   },
   {
      "name": "Ohio",
      "code": "OH"
   },
   {
      "name": "Oklahoma",
      "code": "OK"
   },
   {
      "name": "Oregon",
      "code": "OR"
   },
   {
      "name": "Palau",
      "code": "PW"
   },
   {
      "name": "Pennsylvania",
      "code": "PA"
   },
   {
      "name": "Puerto Rico",
      "code": "PR"
   },
   {
      "name": "Rhode Island",
      "code": "RI"
   },
   {
      "name": "South Carolina",
      "code": "SC"
   },
   {
      "name": "South Dakota",
      "code": "SD"
   },
   {
      "name": "Tennessee",
      "code": "TN"
   },
   {
      "name": "Texas",
      "code": "TX"
   },
   {
      "name": "Utah",
      "code": "UT"
   },
   {
      "name": "Vermont",
      "code": "VT"
   },
   {
      "name": "Virgin Islands",
      "code": "VI"
   },
   {
      "name": "Virginia",
      "code": "VA"
   },
   {
      "name": "Washington",
      "code": "WA"
   },
   {
      "name": "West Virginia",
      "code": "WV"
   },
   {
      "name": "Wisconsin",
      "code": "WI"
   },
   {
      "name": "Wyoming",
      "code": "WY"
   }
] 